(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-carousel]');

    carousels.forEach(function (carousel) {
      const images = Array.from(carousel.querySelectorAll('[data-carousel-image]'));
      const texts = Array.from(carousel.querySelectorAll('[data-carousel-text]'));
      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');

      const total = images.length;
      if (total <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      let current = 0;
      let isAnimating = false;

      const IMAGE_DURATION = 700;
      const TEXT_FADE_DURATION = 300;

      function setDots(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function goTo(nextIndex, direction) {
        if (isAnimating || nextIndex === current) return;
        isAnimating = true;

        const prevIndex = current;
        const enterClass = direction === 'next' ? '' : 'is-leaving-left';
        const leaveClass = direction === 'next' ? 'is-leaving-left' : 'is-leaving-right';

        // ── Image transition ──────────────────────────────
        // Position incoming image off-screen on the correct side
        images[nextIndex].style.transition = 'none';
        images[nextIndex].style.transform =
          direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            images[nextIndex].style.transition = '';
            images[prevIndex].classList.add(leaveClass);
            images[nextIndex].classList.add('is-active');
            images[nextIndex].style.transform = '';
          });
        });

        // ── Text fade out → in ────────────────────────────
        texts[prevIndex].classList.add('is-fading-out');

        setTimeout(function () {
          texts[prevIndex].classList.remove('is-active', 'is-fading-out');
          texts[nextIndex].classList.add('is-active');
        }, TEXT_FADE_DURATION);

        // ── Cleanup ───────────────────────────────────────
        setTimeout(function () {
          images[prevIndex].classList.remove('is-active', leaveClass);
          images[prevIndex].style.transform = '';
          current = nextIndex;
          setDots(current);
          isAnimating = false;
        }, IMAGE_DURATION);
      }

      function next() {
        goTo((current + 1) % total, 'next');
      }

      function prev() {
        goTo((current - 1 + total) % total, 'prev');
      }

      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const target = parseInt(dot.getAttribute('data-carousel-dot'), 10);
          const direction = target > current ? 'next' : 'prev';
          goTo(target, direction);
        });
      });

      // ── Touch / drag ──────────────────────────────────
      let touchStartX = 0;
      let touchStartY = 0;
      let isDragging = false;

      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;

        const deltaX = e.changedTouches[0].clientX - touchStartX;
        const deltaY = e.changedTouches[0].clientY - touchStartY;

        if (Math.abs(deltaX) < 30 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          next();
        } else {
          prev();
        }
      }, { passive: true });

      // ── Mouse drag ────────────────────────────────────
      let mouseStartX = 0;
      let mouseDown = false;

      carousel.addEventListener('mousedown', function (e) {
        mouseStartX = e.clientX;
        mouseDown = true;
      });

      carousel.addEventListener('mouseup', function (e) {
        if (!mouseDown) return;
        mouseDown = false;

        const deltaX = e.clientX - mouseStartX;
        if (Math.abs(deltaX) < 40) return;

        if (deltaX < 0) {
          next();
        } else {
          prev();
        }
      });

      carousel.addEventListener('mouseleave', function () {
        mouseDown = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function getBottleLimit(el) {
      var raw = el.getAttribute('data-bottle-limit');
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 1 ? n : 99;
    }

    function registerVariantLimit(card) {
      if (!card || !window.LuciaRegisterVariantLimit) {
        return;
      }
      var form = card.querySelector('.collection-page__form');
      var variantInput = form && form.querySelector('input[name="id"]');
      if (variantInput) {
        window.LuciaRegisterVariantLimit(variantInput.value, getBottleLimit(card));
      }
    }

    function clampQuantity(value, min, max) {
      var n = parseInt(String(value), 10);
      if (Number.isNaN(n)) {
        n = min;
      }
      if (n < min) {
        n = min;
      }
      if (n > max) {
        n = max;
      }
      return n;
    }

    function parseCartVariantQuantities(cart) {
      var map = {};
      if (!cart || !cart.items) {
        return map;
      }
      cart.items.forEach(function (item) {
        var k = String(item.variant_id);
        map[k] = (map[k] || 0) + item.quantity;
      });
      return map;
    }

    function initCollectionGrid(root) {
      var minQty = 1;
      var labelAdd = root.getAttribute('data-label-add') || '';
      var labelSoldOut = root.getAttribute('data-label-sold-out') || '';

      function syncCard(card, quantities, resetFromCart) {
        var labelLimit = card.getAttribute('data-label-limit') || '';
        var maxCartPerVariant = getBottleLimit(card);
        var form = card.querySelector('.collection-page__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.collection-page__quantity-input');
        var displayQty = form.querySelector('.collection-page__qty-display');
        var minus = form.querySelector('.collection-page__qty-btn--minus');
        var plus = form.querySelector('.collection-page__qty-btn--plus');
        var submitBtn = form.querySelector('.collection-page__submit');
        var variantInput = form.querySelector('input[name="id"]');

        if (!hiddenQty || !displayQty || !minus || !plus || !variantInput) {
          return;
        }

        var available = card.getAttribute('data-product-available') === 'true';
        var variantId = String(variantInput.value);
        var cartQty = quantities[variantId] != null ? quantities[variantId] : 0;
        card.setAttribute('data-cart-quantity', String(cartQty));

        var remaining = Math.max(0, maxCartPerVariant - cartQty);
        var atCartLimit = available && remaining <= 0;
        var maxSelectable =
          available && !atCartLimit
            ? remaining
            : 0;

        var n;
        if (atCartLimit) {
          n = 0;
        } else if (resetFromCart) {
          n = Math.min(1, maxSelectable);
        } else {
          n = clampQuantity(hiddenQty.value, 1, maxSelectable);
        }
        hiddenQty.value = String(n);
        displayQty.textContent = String(n);

        if (submitBtn) {
          if (!available) {
            submitBtn.textContent = labelSoldOut;
          } else if (atCartLimit) {
            submitBtn.textContent = labelLimit;
          } else {
            submitBtn.textContent = labelAdd;
          }
        }

        minus.disabled = !available || atCartLimit || n <= 0;
        plus.disabled = !available || atCartLimit || n >= maxSelectable;
        if (submitBtn) {
          submitBtn.disabled = !available || atCartLimit || n <= 0;
        }
      }

      function readQuantitiesFromDom() {
        var map = {};
        root.querySelectorAll('.collection-page__card').forEach(function (card) {
          var form = card.querySelector('.collection-page__form');
          if (!form) {
            return;
          }
          var variantInput = form.querySelector('input[name="id"]');
          if (!variantInput) {
            return;
          }
          var raw = card.getAttribute('data-cart-quantity');
          var q = parseInt(raw, 10);
          map[String(variantInput.value)] = Number.isFinite(q) ? q : 0;
        });
        return map;
      }

      function updateAllCards(quantities, resetFromCart) {
        root.querySelectorAll('.collection-page__card').forEach(function (card) {
          syncCard(card, quantities, !!resetFromCart);
        });
      }

      function refreshFromCart() {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateAllCards(parseCartVariantQuantities(cart), true);
          })
          .catch(function () {
            updateAllCards(readQuantitiesFromDom(), true);
          });
      }

      document.addEventListener('lucia:cart:updated', function (e) {
        var cart = e.detail && e.detail.cart;
        if (!cart) {
          return;
        }
        updateAllCards(parseCartVariantQuantities(cart), true);
      });

      var initialQuantities = readQuantitiesFromDom();
      root.querySelectorAll('.collection-page__card').forEach(function (card) {
        var form = card.querySelector('.collection-page__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.collection-page__quantity-input');
        var displayQty = form.querySelector('.collection-page__qty-display');
        var minus = form.querySelector('.collection-page__qty-btn--minus');
        var plus = form.querySelector('.collection-page__qty-btn--plus');

        if (!hiddenQty || !displayQty || !minus || !plus) {
          return;
        }

        function localQuantities() {
          var map = {};
          root.querySelectorAll('.collection-page__card').forEach(function (c) {
            var f = c.querySelector('.collection-page__form');
            if (!f) {
              return;
            }
            var vi = f.querySelector('input[name="id"]');
            if (!vi) {
              return;
            }
            var raw = c.getAttribute('data-cart-quantity');
            var q = parseInt(raw, 10);
            map[String(vi.value)] = Number.isFinite(q) ? q : 0;
          });
          return map;
        }

        function syncFromDom() {
          updateAllCards(localQuantities(), false);
        }

        minus.addEventListener('click', function () {
          if (minus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) - 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        plus.addEventListener('click', function () {
          if (plus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) + 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var submitBtn = form.querySelector('.collection-page__submit');
          if (submitBtn && submitBtn.disabled) {
            return;
          }

          var variantId = form.querySelector('input[name="id"]').value;
          var quantity = parseInt(hiddenQty.value, 10) || 1;

          if (submitBtn) {
            submitBtn.disabled = true;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              hiddenQty.value = '1';
              registerVariantLimit(card);
              return refreshFromCart();
            })
            .then(function () {
              if (window.CartDrawer) {
                window.CartDrawer.open();
              }
            })
            .catch(function (err) {
              console.error('Erro ao adicionar ao carrinho:', err);
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
              }
              syncCard(card, localQuantities(), false);
            });
        });
      });

      updateAllCards(initialQuantities, true);
    }

    document.querySelectorAll('[data-collection-grid]').forEach(initCollectionGrid);

    document.querySelectorAll('[data-collection-category-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = select.value;
        if (url) {
          window.location.assign(url);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-light"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) {
        return;
      }
      var trigger = target.closest('[data-faq-light-trigger]');
      if (!trigger) {
        return;
      }
      var item = trigger.closest('[data-faq-light-item]');
      if (!item) {
        return;
      }
      e.preventDefault();
      var panel = item.querySelector('.faq-light-item__panel');
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.setAttribute('aria-hidden', 'true');
        }
      } else {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.setAttribute('aria-hidden', 'false');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) {
        return;
      }
      var trigger = target.closest('[data-faq-trigger]');
      if (!trigger) {
        return;
      }
      var item = trigger.closest('[data-faq-item]');
      if (!item) {
        return;
      }
      e.preventDefault();
      var panel = item.querySelector('.faq-item__panel');
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.setAttribute('aria-hidden', 'true');
        }
      } else {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.setAttribute('aria-hidden', 'false');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      const isOpen = menu.classList.contains('is-open');

      if (isOpen) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    menu.querySelectorAll('.header__mobile-menu-item').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    // Target: 2026-05-08 at 12:00 BRT (UTC-3) = 15:00 UTC
    var target = new Date('2026-05-08T15:00:00Z');

    var elDays = document.getElementById('pw-days');
    var elHours = document.getElementById('pw-hours');
    var elMinutes = document.getElementById('pw-minutes');
    var elSeconds = document.getElementById('pw-seconds');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();
      var diff = target - now;

      if (diff <= 0) {
        elDays.textContent = '00';
        elHours.textContent = '00';
        elMinutes.textContent = '00';
        elSeconds.textContent = '00';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      elDays.textContent = pad(days);
      elHours.textContent = pad(hours);
      elMinutes.textContent = pad(minutes);
      elSeconds.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);

    /* Restore: abrir/fechar overlay do formulário de senha (requer HTML do footer e overlay descomentados).
    var accessBtn = document.getElementById('pw-access-btn');
    var overlay = document.getElementById('pw-form-overlay');
    var closeBtn = document.getElementById('pw-close-btn');
    var passwordInput = document.getElementById('password-input');

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      accessBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        if (passwordInput) passwordInput.focus();
      }, 350);
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      accessBtn.setAttribute('aria-expanded', 'false');
      accessBtn.focus();
    }

    accessBtn.addEventListener('click', openOverlay);
    closeBtn.addEventListener('click', closeOverlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeOverlay();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeOverlay();
      }
    });
    */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getBottleLimit(el) {
      var raw = el.getAttribute('data-bottle-limit');
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 1 ? n : 99;
    }

    function registerVariantLimit(card) {
      if (!card || !window.LuciaRegisterVariantLimit) {
        return;
      }
      var form = card.querySelector('.product-gallery__form');
      var variantInput = form && form.querySelector('input[name="id"]');
      if (variantInput) {
        window.LuciaRegisterVariantLimit(variantInput.value, getBottleLimit(card));
      }
    }

    function clampQuantity(value, min, max) {
      var n = parseInt(String(value), 10);
      if (Number.isNaN(n)) {
        n = min;
      }
      if (n < min) {
        n = min;
      }
      if (n > max) {
        n = max;
      }
      return n;
    }

    function parseCartVariantQuantities(cart) {
      var map = {};
      if (!cart || !cart.items) {
        return map;
      }
      cart.items.forEach(function (item) {
        var k = String(item.variant_id);
        map[k] = (map[k] || 0) + item.quantity;
      });
      return map;
    }

    function initGallery(root) {
      var minQty = 1;
      var labelAdd = root.getAttribute('data-label-add') || '';
      var labelSoldOut = root.getAttribute('data-label-sold-out') || '';

      function syncCard(card, quantities, resetFromCart) {
        var labelLimit = card.getAttribute('data-label-limit') || '';
        var maxCartPerVariant = getBottleLimit(card);
        var form = card.querySelector('.product-gallery__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.product-gallery__quantity-input');
        var displayQty = form.querySelector('.product-gallery__qty-display');
        var minus = form.querySelector('.product-gallery__qty-btn--minus');
        var plus = form.querySelector('.product-gallery__qty-btn--plus');
        var submitBtn = form.querySelector('.product-gallery__submit');
        var variantInput = form.querySelector('input[name="id"]');

        if (!hiddenQty || !displayQty || !minus || !plus || !variantInput) {
          return;
        }

        var available = card.getAttribute('data-product-available') === 'true';
        var variantId = String(variantInput.value);
        var cartQty = quantities[variantId] != null ? quantities[variantId] : 0;
        card.setAttribute('data-cart-quantity', String(cartQty));

        var remaining = Math.max(0, maxCartPerVariant - cartQty);
        var atCartLimit = available && remaining <= 0;
        var maxSelectable =
          available && !atCartLimit
            ? remaining
            : 0;

        var n;
        if (atCartLimit) {
          n = 0;
        } else if (resetFromCart) {
          n = Math.min(1, maxSelectable);
        } else {
          n = clampQuantity(hiddenQty.value, 1, maxSelectable);
        }
        hiddenQty.value = String(n);
        displayQty.textContent = String(n);

        if (submitBtn) {
          if (!available) {
            submitBtn.textContent = labelSoldOut;
          } else if (atCartLimit) {
            submitBtn.textContent = labelLimit;
          } else {
            submitBtn.textContent = labelAdd;
          }
        }

        minus.disabled = !available || atCartLimit || n <= 0;
        plus.disabled = !available || atCartLimit || n >= maxSelectable;
        if (submitBtn) {
          submitBtn.disabled = !available || atCartLimit || n <= 0;
        }
      }

      function readQuantitiesFromDom() {
        var map = {};
        root.querySelectorAll('.product-gallery__card').forEach(function (card) {
          var form = card.querySelector('.product-gallery__form');
          if (!form) {
            return;
          }
          var variantInput = form.querySelector('input[name="id"]');
          if (!variantInput) {
            return;
          }
          var raw = card.getAttribute('data-cart-quantity');
          var q = parseInt(raw, 10);
          map[String(variantInput.value)] = Number.isFinite(q) ? q : 0;
        });
        return map;
      }

      function updateAllCards(quantities, resetFromCart) {
        root.querySelectorAll('.product-gallery__card').forEach(function (card) {
          syncCard(card, quantities, !!resetFromCart);
        });
      }

      function refreshFromCart() {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateAllCards(parseCartVariantQuantities(cart), true);
          })
          .catch(function () {
            updateAllCards(readQuantitiesFromDom(), true);
          });
      }

      document.addEventListener('lucia:cart:updated', function (e) {
        var cart = e.detail && e.detail.cart;
        if (!cart) {
          return;
        }
        updateAllCards(parseCartVariantQuantities(cart), true);
      });

      var initialQuantities = readQuantitiesFromDom();
      root.querySelectorAll('.product-gallery__card').forEach(function (card) {
        var form = card.querySelector('.product-gallery__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.product-gallery__quantity-input');
        var displayQty = form.querySelector('.product-gallery__qty-display');
        var minus = form.querySelector('.product-gallery__qty-btn--minus');
        var plus = form.querySelector('.product-gallery__qty-btn--plus');

        if (!hiddenQty || !displayQty || !minus || !plus) {
          return;
        }

        function localQuantities() {
          var map = {};
          root.querySelectorAll('.product-gallery__card').forEach(function (c) {
            var f = c.querySelector('.product-gallery__form');
            if (!f) {
              return;
            }
            var vi = f.querySelector('input[name="id"]');
            if (!vi) {
              return;
            }
            var raw = c.getAttribute('data-cart-quantity');
            var q = parseInt(raw, 10);
            map[String(vi.value)] = Number.isFinite(q) ? q : 0;
          });
          return map;
        }

        function syncFromDom() {
          updateAllCards(localQuantities(), false);
        }

        minus.addEventListener('click', function () {
          if (minus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) - 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        plus.addEventListener('click', function () {
          if (plus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) + 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var submitBtn = form.querySelector('.product-gallery__submit');
          if (submitBtn && submitBtn.disabled) {
            return;
          }

          var variantId = form.querySelector('input[name="id"]').value;
          var quantity = parseInt(hiddenQty.value, 10) || 1;

          if (submitBtn) {
            submitBtn.disabled = true;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              hiddenQty.value = '1';
              registerVariantLimit(card);
              return refreshFromCart();
            })
            .then(function () {
              if (window.CartDrawer) {
                window.CartDrawer.open();
              }
            })
            .catch(function (err) {
              console.error('Erro ao adicionar ao carrinho:', err);
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
              }
              syncCard(card, localQuantities(), false);
            });
        });
      });

      updateAllCards(initialQuantities, true);
    }

    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-with-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getBottleLimit(el) {
      var raw = el.getAttribute('data-bottle-limit');
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 1 ? n : 99;
    }

    function registerVariantLimit(card) {
      if (!card || !window.LuciaRegisterVariantLimit) {
        return;
      }
      var form = card.querySelector('.product-with-image__form');
      var variantInput = form && form.querySelector('input[name="id"]');
      if (variantInput) {
        window.LuciaRegisterVariantLimit(variantInput.value, getBottleLimit(card));
      }
    }

    function clampQuantity(value, min, max) {
      var n = parseInt(String(value), 10);
      if (Number.isNaN(n)) {
        n = min;
      }
      if (n < min) {
        n = min;
      }
      if (n > max) {
        n = max;
      }
      return n;
    }

    function parseCartVariantQuantities(cart) {
      var map = {};
      if (!cart || !cart.items) {
        return map;
      }
      cart.items.forEach(function (item) {
        var k = String(item.variant_id);
        map[k] = (map[k] || 0) + item.quantity;
      });
      return map;
    }

    function initGallery(root) {
      var minQty = 1;
      var labelAdd = root.getAttribute('data-label-add') || '';
      var labelSoldOut = root.getAttribute('data-label-sold-out') || '';

      function syncCard(card, quantities, resetFromCart) {
        var labelLimit = card.getAttribute('data-label-limit') || '';
        var maxCartPerVariant = getBottleLimit(card);
        var form = card.querySelector('.product-with-image__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.product-with-image__quantity-input');
        var displayQty = form.querySelector('.product-with-image__qty-display');
        var minus = form.querySelector('.product-with-image__qty-btn--minus');
        var plus = form.querySelector('.product-with-image__qty-btn--plus');
        var submitBtn = form.querySelector('.product-with-image__submit');
        var variantInput = form.querySelector('input[name="id"]');

        if (!hiddenQty || !displayQty || !minus || !plus || !variantInput) {
          return;
        }

        var available = card.getAttribute('data-product-available') === 'true';
        var variantId = String(variantInput.value);
        var cartQty = quantities[variantId] != null ? quantities[variantId] : 0;
        card.setAttribute('data-cart-quantity', String(cartQty));

        var remaining = Math.max(0, maxCartPerVariant - cartQty);
        var atCartLimit = available && remaining <= 0;
        var maxSelectable =
          available && !atCartLimit
            ? remaining
            : 0;

        var n;
        if (atCartLimit) {
          n = 0;
        } else if (resetFromCart) {
          n = Math.min(1, maxSelectable);
        } else {
          n = clampQuantity(hiddenQty.value, 1, maxSelectable);
        }
        hiddenQty.value = String(n);
        displayQty.textContent = String(n);

        if (submitBtn) {
          if (!available) {
            submitBtn.textContent = labelSoldOut;
          } else if (atCartLimit) {
            submitBtn.textContent = labelLimit;
          } else {
            submitBtn.textContent = labelAdd;
          }
        }

        minus.disabled = !available || atCartLimit || n <= 0;
        plus.disabled = !available || atCartLimit || n >= maxSelectable;
        if (submitBtn) {
          submitBtn.disabled = !available || atCartLimit || n <= 0;
        }
      }

      function readQuantitiesFromDom() {
        var map = {};
        root.querySelectorAll('.product-with-image__card').forEach(function (card) {
          var form = card.querySelector('.product-with-image__form');
          if (!form) {
            return;
          }
          var variantInput = form.querySelector('input[name="id"]');
          if (!variantInput) {
            return;
          }
          var raw = card.getAttribute('data-cart-quantity');
          var q = parseInt(raw, 10);
          map[String(variantInput.value)] = Number.isFinite(q) ? q : 0;
        });
        return map;
      }

      function updateAllCards(quantities, resetFromCart) {
        root.querySelectorAll('.product-with-image__card').forEach(function (card) {
          syncCard(card, quantities, !!resetFromCart);
        });
      }

      function refreshFromCart() {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateAllCards(parseCartVariantQuantities(cart), true);
          })
          .catch(function () {
            updateAllCards(readQuantitiesFromDom(), true);
          });
      }

      document.addEventListener('lucia:cart:updated', function (e) {
        var cart = e.detail && e.detail.cart;
        if (!cart) {
          return;
        }
        updateAllCards(parseCartVariantQuantities(cart), true);
      });

      var initialQuantities = readQuantitiesFromDom();
      root.querySelectorAll('.product-with-image__card').forEach(function (card) {
        var form = card.querySelector('.product-with-image__form');
        if (!form) {
          return;
        }

        var hiddenQty = form.querySelector('.product-with-image__quantity-input');
        var displayQty = form.querySelector('.product-with-image__qty-display');
        var minus = form.querySelector('.product-with-image__qty-btn--minus');
        var plus = form.querySelector('.product-with-image__qty-btn--plus');

        if (!hiddenQty || !displayQty || !minus || !plus) {
          return;
        }

        function localQuantities() {
          var map = {};
          root.querySelectorAll('.product-with-image__card').forEach(function (c) {
            var f = c.querySelector('.product-with-image__form');
            if (!f) {
              return;
            }
            var vi = f.querySelector('input[name="id"]');
            if (!vi) {
              return;
            }
            var raw = c.getAttribute('data-cart-quantity');
            var q = parseInt(raw, 10);
            map[String(vi.value)] = Number.isFinite(q) ? q : 0;
          });
          return map;
        }

        function syncFromDom() {
          updateAllCards(localQuantities(), false);
        }

        minus.addEventListener('click', function () {
          if (minus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) - 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        plus.addEventListener('click', function () {
          if (plus.disabled) {
            return;
          }
          var qs = localQuantities();
          var variantInput = form.querySelector('input[name="id"]');
          var cartQty = variantInput ? qs[String(variantInput.value)] || 0 : 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var available = card.getAttribute('data-product-available') === 'true';
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? remaining
              : 0;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) + 1, 1, maxSelectable)
          );
          syncFromDom();
        });

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var submitBtn = form.querySelector('.product-with-image__submit');
          if (submitBtn && submitBtn.disabled) {
            return;
          }

          var variantId = form.querySelector('input[name="id"]').value;
          var quantity = parseInt(hiddenQty.value, 10) || 1;

          if (submitBtn) {
            submitBtn.disabled = true;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              hiddenQty.value = '1';
              registerVariantLimit(card);
              return refreshFromCart();
            })
            .then(function () {
              if (window.CartDrawer) {
                window.CartDrawer.open();
              }
            })
            .catch(function (err) {
              console.error('Erro ao adicionar ao carrinho:', err);
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
              }
              syncCard(card, localQuantities(), false);
            });
        });
      });

      updateAllCards(initialQuantities, true);
    }

    document.querySelectorAll('[data-product-with-image]').forEach(initGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function clampQuantity(value, min, max) {
      var n = parseInt(String(value), 10);
      if (Number.isNaN(n)) {
        n = min;
      }
      if (n < min) {
        n = min;
      }
      if (n > max) {
        n = max;
      }
      return n;
    }

    function initProductMain(root) {
      var MAX_CART_PER_VARIANT = 3;
      var rawMax = root.getAttribute('data-max-quantity');
      var parsed = parseInt(rawMax, 10);
      var editorMaxQty = Number.isFinite(parsed) && parsed >= 1 ? parsed : 10;
      var minQty = 1;

      var form = root.querySelector('.product-main__form');
      if (!form) {
        return;
      }

      var hiddenQty = form.querySelector('.product-main__quantity-input');
      var displayQty = form.querySelector('.product-main__qty-display');
      var minus = form.querySelector('.product-main__qty-btn--minus');
      var plus = form.querySelector('.product-main__qty-btn--plus');
      var submitBtn = form.querySelector('[data-product-main-submit]');
      var priceEl = root.querySelector('[data-product-main-price]');
      var variantSelect = form.querySelector('[data-product-main-variant]');
      var variantHidden = form.querySelector('[data-product-main-variant-hidden]');

      var variantQuantities = {};

      function parseCartVariantQuantities(cart) {
        var map = {};
        if (!cart || !cart.items) {
          return map;
        }
        cart.items.forEach(function (item) {
          var k = String(item.variant_id);
          map[k] = (map[k] || 0) + item.quantity;
        });
        return map;
      }

      function loadQuantitiesFromDom() {
        variantQuantities = {};
        if (variantSelect) {
          Array.prototype.forEach.call(variantSelect.options, function (opt) {
            var raw = opt.getAttribute('data-cart-quantity');
            variantQuantities[opt.value] = parseInt(raw, 10) || 0;
          });
        } else if (variantHidden) {
          var rq = root.getAttribute('data-cart-quantity');
          variantQuantities[variantHidden.value] = parseInt(rq, 10) || 0;
        }
      }

      function applyQuantitiesToDom() {
        if (variantSelect) {
          Array.prototype.forEach.call(variantSelect.options, function (opt) {
            var q =
              variantQuantities[opt.value] != null ? variantQuantities[opt.value] : 0;
            opt.setAttribute('data-cart-quantity', String(q));
          });
        } else if (variantHidden) {
          var q =
            variantQuantities[variantHidden.value] != null
              ? variantQuantities[variantHidden.value]
              : 0;
          root.setAttribute('data-cart-quantity', String(q));
        }
      }

      function getCurrentVariantId() {
        var idField = form.querySelector('[name="id"]');
        return idField && idField.value ? String(idField.value) : '';
      }

      function getCurrentAvailability() {
        if (variantSelect) {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          return opt ? opt.getAttribute('data-available') === 'true' : false;
        }
        if (variantHidden) {
          return variantHidden.getAttribute('data-available') === 'true';
        }
        return false;
      }

      function getCartQtyForCurrentVariant() {
        var vid = getCurrentVariantId();
        if (!vid) {
          return 0;
        }
        if (variantQuantities[vid] != null) {
          return variantQuantities[vid];
        }
        if (variantSelect) {
          var opt = variantSelect.querySelector('option[value="' + vid + '"]');
          if (opt) {
            var raw = opt.getAttribute('data-cart-quantity');
            return parseInt(raw, 10) || 0;
          }
        }
        var rq = root.getAttribute('data-cart-quantity');
        return parseInt(rq, 10) || 0;
      }

      function syncBuyAndQuantity() {
        if (!hiddenQty || !displayQty) {
          return;
        }
        var available = getCurrentAvailability();
        var cartQty = getCartQtyForCurrentVariant();
        var remaining = Math.max(0, MAX_CART_PER_VARIANT - cartQty);
        var atCartLimit = available && remaining <= 0;
        var maxSelectable =
          available && !atCartLimit
            ? Math.min(editorMaxQty, remaining)
            : minQty;

        var n = clampQuantity(hiddenQty.value, minQty, maxSelectable);
        hiddenQty.value = String(n);
        displayQty.textContent = String(n);

        var addLabel = submitBtn && submitBtn.getAttribute('data-label-add');
        var limitLabel = submitBtn && submitBtn.getAttribute('data-label-limit');
        var soldLabel = submitBtn && submitBtn.getAttribute('data-label-sold');

        if (minus) {
          minus.disabled = !available || atCartLimit || n <= minQty;
        }
        if (plus) {
          plus.disabled = !available || atCartLimit || n >= maxSelectable;
        }
        if (submitBtn) {
          if (!available) {
            submitBtn.disabled = true;
            if (soldLabel) {
              submitBtn.textContent = soldLabel;
            }
          } else if (atCartLimit) {
            submitBtn.disabled = true;
            if (limitLabel) {
              submitBtn.textContent = limitLabel;
            }
          } else {
            submitBtn.disabled = false;
            if (addLabel) {
              submitBtn.textContent = addLabel;
            }
          }
        }
      }

      function refreshFromCart() {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            variantQuantities = parseCartVariantQuantities(cart);
            applyQuantitiesToDom();
            syncBuyAndQuantity();
          })
          .catch(function () {
            loadQuantitiesFromDom();
            syncBuyAndQuantity();
          });
      }

      if (variantSelect && priceEl) {
        variantSelect.addEventListener('change', function () {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          if (!opt) {
            return;
          }
          var p = opt.getAttribute('data-price');
          if (p) {
            priceEl.textContent = p;
          }
          syncBuyAndQuantity();
        });
      }

      if (minus && hiddenQty && displayQty) {
        minus.addEventListener('click', function () {
          if (minus.disabled) {
            return;
          }
          var available = getCurrentAvailability();
          var cartQty = getCartQtyForCurrentVariant();
          var remaining = Math.max(0, MAX_CART_PER_VARIANT - cartQty);
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? Math.min(editorMaxQty, remaining)
              : minQty;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) - 1, minQty, maxSelectable)
          );
          syncBuyAndQuantity();
        });
      }

      if (plus && hiddenQty && displayQty) {
        plus.addEventListener('click', function () {
          if (plus.disabled) {
            return;
          }
          var available = getCurrentAvailability();
          var cartQty = getCartQtyForCurrentVariant();
          var remaining = Math.max(0, MAX_CART_PER_VARIANT - cartQty);
          var atCartLimit = available && remaining <= 0;
          var maxSelectable =
            available && !atCartLimit
              ? Math.min(editorMaxQty, remaining)
              : minQty;
          hiddenQty.value = String(
            clampQuantity(parseInt(hiddenQty.value, 10) + 1, minQty, maxSelectable)
          );
          syncBuyAndQuantity();
        });
      }

      loadQuantitiesFromDom();
      syncBuyAndQuantity();

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (submitBtn && submitBtn.disabled) {
          return;
        }

        var idField = form.querySelector('[name="id"]');
        if (!idField || !idField.value) {
          return;
        }

        var variantId = idField.value;
        var quantity = parseInt(hiddenQty ? hiddenQty.value : '1', 10) || 1;

        if (submitBtn) {
          submitBtn.disabled = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            if (hiddenQty && displayQty) {
              hiddenQty.value = '1';
            }
            return refreshFromCart();
          })
          .then(function () {
            if (window.CartDrawer) {
              window.CartDrawer.open();
            }
          })
          .catch(function (err) {
            console.error('Erro ao adicionar ao carrinho:', err);
          })
          .finally(function () {
            syncBuyAndQuantity();
          });
      });
    }

    document.querySelectorAll('[data-product-main]').forEach(initProductMain);

    function updateInfoStickyTop() {
      if (window.innerWidth < 990) return;
      document.querySelectorAll('[data-product-main]').forEach(function (root) {
        var info = root.querySelector('.product-main__info');
        if (!info) return;
        var headerH = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 0;
        var viewH = window.innerHeight;
        var infoH = info.offsetHeight;
        var top = headerH + (viewH - headerH - infoH) / 2;
        if (top < headerH + 16) top = headerH + 16;
        info.style.setProperty('--info-sticky-top', top + 'px');
      });
    }

    updateInfoStickyTop();
    window.addEventListener('resize', updateInfoStickyTop);

    function destroyProductCarousel(root) {
      var state = root._productCarouselState;
      if (!state) {
        return;
      }
      clearInterval(state.autoplayId);
      state.track.removeEventListener('transitionend', state.onTransitionEnd);
      state.media.removeEventListener('touchstart', state.onTouchStart);
      state.media.removeEventListener('touchend', state.onTouchEnd);
      if (state.prependClone && state.prependClone.parentNode) {
        state.prependClone.remove();
      }
      if (state.appendClone && state.appendClone.parentNode) {
        state.appendClone.remove();
      }
      state.track.style.transform = '';
      state.track.style.transition = '';
      delete root._productCarouselState;
    }

    function initProductCarousel(root) {
      destroyProductCarousel(root);

      if (window.innerWidth >= 990) {
        return;
      }

      var media = root.querySelector('.product-main__media');
      var track = root.querySelector('.product-main__carousel-track');
      if (!media || !track) {
        return;
      }

      var originals = track.querySelectorAll('.product-main__media-item');
      var originalCount = originals.length;
      if (originalCount <= 1) {
        return;
      }

      var first = originals[0];
      var last = originals[originals.length - 1];
      var prependClone = last.cloneNode(true);
      var appendClone = first.cloneNode(true);
      prependClone.setAttribute('data-carousel-clone', 'prepend');
      appendClone.setAttribute('data-carousel-clone', 'append');
      prependClone.setAttribute('aria-hidden', 'true');
      appendClone.setAttribute('aria-hidden', 'true');
      track.insertBefore(prependClone, first);
      track.appendChild(appendClone);

      var current = 1;
      var animating = false;

      function slideWidth() {
        return media.offsetWidth || 0;
      }

      function setTransform(index, instant) {
        var w = slideWidth();
        var offset = -index * w;
        track.style.transition = instant ? 'none' : 'transform 0.45s ease-out';
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      setTransform(current, true);
      void track.offsetWidth;

      function onTransitionEnd(e) {
        if (e.propertyName !== 'transform') {
          return;
        }
        if (current === 0) {
          current = originalCount;
          setTransform(current, true);
        } else if (current === originalCount + 1) {
          current = 1;
          setTransform(current, true);
        }
        animating = false;
      }

      function goNext() {
        if (window.innerWidth >= 990) {
          return;
        }
        if (animating) {
          return;
        }
        animating = true;
        current += 1;
        setTransform(current, false);
      }

      function goPrev() {
        if (window.innerWidth >= 990) {
          return;
        }
        if (animating) {
          return;
        }
        animating = true;
        current -= 1;
        setTransform(current, false);
      }

      var autoplayId = setInterval(goNext, 7000);

      function restartAutoplay() {
        clearInterval(autoplayId);
        autoplayId = setInterval(goNext, 7000);
      }

      var touchStartX = 0;
      var touchStartY = 0;

      function onTouchStart(e) {
        if (window.innerWidth >= 990) {
          return;
        }
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }

      function onTouchEnd(e) {
        if (window.innerWidth >= 990) {
          return;
        }
        var dx = e.changedTouches[0].screenX - touchStartX;
        var dy = e.changedTouches[0].screenY - touchStartY;
        if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) {
          return;
        }
        restartAutoplay();
        if (dx < 0) {
          goNext();
        } else {
          goPrev();
        }
      }

      track.addEventListener('transitionend', onTransitionEnd);
      media.addEventListener('touchstart', onTouchStart, { passive: true });
      media.addEventListener('touchend', onTouchEnd, { passive: true });

      function refreshTransform(instant) {
        setTransform(current, instant);
      }

      root._productCarouselState = {
        autoplayId: autoplayId,
        track: track,
        media: media,
        onTransitionEnd: onTransitionEnd,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        prependClone: prependClone,
        appendClone: appendClone,
        refreshTransform: refreshTransform,
      };
    }

    function syncProductCarousels() {
      document.querySelectorAll('[data-product-main]').forEach(function (root) {
        var track = root.querySelector('.product-main__carousel-track');
        if (!track) {
          return;
        }
        var count = track.querySelectorAll('.product-main__media-item:not([data-carousel-clone])').length;
        var wantsCarousel = window.innerWidth < 990 && count > 1;
        var state = root._productCarouselState;

        if (wantsCarousel && !state) {
          initProductCarousel(root);
          return;
        }
        if (!wantsCarousel && state) {
          destroyProductCarousel(root);
          return;
        }
        if (wantsCarousel && state && typeof state.refreshTransform === 'function') {
          state.refreshTransform(true);
        }
      });
    }

    syncProductCarousels();
    window.addEventListener('resize', syncProductCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-more"]) return;
  try {
    
  (function () {
    function initShopMore(container) {
      var url = container.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var incoming = doc.getElementById(container.id);
          if (incoming) {
            container.innerHTML = incoming.innerHTML;
            initCounters(container);
          }
        })
        .catch(function () {});
    }

    function getBottleLimit(el) {
      var raw = el.getAttribute('data-bottle-limit');
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 1 ? n : 99;
    }

    function parseCartVariantQuantities(cart) {
      var map = {};
      if (!cart || !cart.items) {
        return map;
      }
      cart.items.forEach(function (item) {
        var k = String(item.variant_id);
        map[k] = (map[k] || 0) + item.quantity;
      });
      return map;
    }

    function initCounters(root) {
      var labelAdd = root.getAttribute('data-label-add') || '';
      var labelSoldOut = root.getAttribute('data-label-sold-out') || '';

      function syncCard(card, quantities, resetFromCart) {
        var form = card.querySelector('.shop-more__card-form');
        if (!form) {
          return;
        }

        var labelLimit = card.getAttribute('data-label-limit') || '';
        var qtyInput = form.querySelector('.shop-more__qty-input');
        var display = form.querySelector('.shop-more__qty-display');
        var minus = form.querySelector('.shop-more__qty-btn--minus');
        var plus = form.querySelector('.shop-more__qty-btn--plus');
        var submitBtn = form.querySelector('.shop-more__submit');
        var variantInput = form.querySelector('input[name="id"]');

        if (!qtyInput || !display || !minus || !plus || !variantInput) {
          return;
        }

        var available = card.getAttribute('data-product-available') === 'true';
        var variantId = String(variantInput.value);
        var cartQty = quantities[variantId] != null ? quantities[variantId] : 0;
        card.setAttribute('data-cart-quantity', String(cartQty));

        var maxCartPerVariant = getBottleLimit(card);
        var remaining = Math.max(0, maxCartPerVariant - cartQty);
        var atCartLimit = available && remaining <= 0;
        var maxSelectable =
          available && !atCartLimit ? remaining : 0;

        var n;
        if (atCartLimit) {
          n = 0;
        } else if (resetFromCart) {
          n = Math.min(1, maxSelectable);
        } else {
          var current = parseInt(qtyInput.value, 10) || 1;
          n = Math.min(maxSelectable, Math.max(1, current));
        }
        qtyInput.value = String(n);
        display.textContent = String(n);

        minus.disabled = !available || atCartLimit || n <= 0;
        plus.disabled = !available || atCartLimit || n >= maxSelectable;

        if (submitBtn) {
          if (!available) {
            submitBtn.textContent = labelSoldOut;
          } else if (atCartLimit) {
            submitBtn.textContent = labelLimit;
          } else {
            submitBtn.textContent = labelAdd;
          }
          submitBtn.disabled = !available || atCartLimit || n <= 0;
        }
      }

      function readQuantitiesFromDom() {
        var map = {};
        root.querySelectorAll('.shop-more__card').forEach(function (card) {
          var form = card.querySelector('.shop-more__card-form');
          if (!form) {
            return;
          }
          var variantInput = form.querySelector('input[name="id"]');
          if (!variantInput) {
            return;
          }
          var raw = card.getAttribute('data-cart-quantity');
          var q = parseInt(raw, 10);
          map[String(variantInput.value)] = Number.isFinite(q) ? q : 0;
        });
        return map;
      }

      function updateAllCards(quantities, resetFromCart) {
        root.querySelectorAll('.shop-more__card').forEach(function (card) {
          syncCard(card, quantities, !!resetFromCart);
        });
      }

      function refreshFromCart() {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateAllCards(parseCartVariantQuantities(cart), true);
          })
          .catch(function () {
            updateAllCards(readQuantitiesFromDom(), true);
          });
      }

      if (!root.dataset.cartSyncBound) {
        root.dataset.cartSyncBound = 'true';
        document.addEventListener('lucia:cart:updated', function (e) {
          if (!root.isConnected) {
            return;
          }
          var cart = e.detail && e.detail.cart;
          if (!cart) {
            return;
          }
          updateAllCards(parseCartVariantQuantities(cart), true);
        });
      }

      root.querySelectorAll('.shop-more__card').forEach(function (card) {
        var form = card.querySelector('.shop-more__card-form');
        if (!form || form.dataset.qtyBound) {
          return;
        }
        form.dataset.qtyBound = 'true';

        var qtyInput = form.querySelector('.shop-more__qty-input');
        var display = form.querySelector('.shop-more__qty-display');
        var minus = form.querySelector('.shop-more__qty-btn--minus');
        var plus = form.querySelector('.shop-more__qty-btn--plus');

        if (!qtyInput || !display || !minus || !plus) {
          return;
        }

        function localQuantities() {
          return readQuantitiesFromDom();
        }

        function syncFromDom() {
          updateAllCards(localQuantities(), false);
        }

        minus.addEventListener('click', function () {
          if (minus.disabled) {
            return;
          }
          var current = parseInt(qtyInput.value, 10) || 1;
          var next = Math.max(1, current - 1);
          qtyInput.value = String(next);
          display.textContent = String(next);
          syncFromDom();
        });

        plus.addEventListener('click', function () {
          if (plus.disabled) {
            return;
          }
          var current = parseInt(qtyInput.value, 10) || 1;
          var cartQty = parseInt(card.getAttribute('data-cart-quantity'), 10) || 0;
          var remaining = Math.max(0, getBottleLimit(card) - cartQty);
          var ms = remaining < 1 ? 0 : remaining;
          var next = Math.min(ms, current + 1);
          qtyInput.value = String(next);
          display.textContent = String(next);
          syncFromDom();
        });
      });

      updateAllCards(readQuantitiesFromDom(), true);
    }

    document.querySelectorAll('[data-url*="product_recommendations"]').forEach(function (el) {
      if (el.id && el.id.startsWith('ShopMore-')) {
        initCounters(el);
        initShopMore(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
